var exports = {
  "Q": "x234b8571--3c59f1--content",
};

module.exports = exports;
